import Swiper from 'swiper';
const VenueSlider = {
    _swiperVenueObj: '',
    init() {
        if ($('.venue__swiper').length > 0) {
            this.initSlider();
        }
    },
    initSlider() {
        this._swiperVenueObj = new Swiper($('.venue__swiper')[0], {
            spaceBetween: 10,
            slidesPerView: 2,
            centeredSlides: true,
            loop: true,
            autoplay: {
                delay: 3000,
                // disableOnInteraction: true,
            },
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            breakpoints: {
                768: {
                    slidesPerView: 2,
                    centeredSlides: true,
                    spaceBetween: 10,
                },
                1024: {
                    slidesPerView: 2,
                    centeredSlides: true,
                    spaceBetween: 10,
                },
            },

        });

    },
}
export default VenueSlider;


// WEBPACK FOOTER //
// ./scripts/modules/components/_venue-slider.js